import React, { useState } from "react";
import CountUp from "react-countup";
import "./Achievements.css";

export default function Achievements() {
  const [numbers, setnumbers] = useState([]);
  return (
    <div>
      <section className="achiev-grid">
        <div className="achiev-card">
          <h1 className="career-detail-heading">
            <CountUp duration={3} delay={2} end={26} />
          </h1>
          {/* <FaUserCheck size="80" /> */}
          <h5 className="career-detail-heading">Projects Completed</h5>
        </div>

        <div className="achiev-card">
          <h1 className="career-detail-heading">
            <CountUp duration={3} delay={3} end={17} />
          </h1>
          {/* <FaMoneyCheck size="50" /> */}
          <h5 className="career-detail-heading">Happy Customers</h5>
        </div>

        <div className="achiev-card">
          <h1 className="career-detail-heading">
            <CountUp duration={3} delay={3} end={33} />
          </h1>
          {/* <FaUserNinja size="50" /> */}
          <h5 className="career-detail-heading">Team Members</h5>
        </div>

        <div className="achiev-card">
          <h1 className="career-detail-heading">
            <CountUp duration={3} delay={3} end={17} />
          </h1>
          {/* <FaUserCheck size="50" /> */}
          <h5 className="career-detail-heading">Happy Customers</h5>
        </div>
      </section>
    </div>
  );
}
